<template>
  <div
    class="cascader-panel"
    :style="width?('min-width:'+width+'px'):''+','+height?('min-height:'+height+'px'):''"
  >
    <ul class="cascader-panel-ul" v-if="data && data.length" @mouseover="handlemouseover">
      <cascader-item
        :class="[{isactive:currentIndex===index}]"
        v-for="(item,index) in data"
        :data="item"
        :key="item.id"
        @mouseenter.native.stop="showChild(item,index)"
        @getAcived="getAcived"
      ></cascader-item>
      <!-- <div @mouseenter="enterul()" style="height:100%;background-color:red;"></div> -->
    </ul>
    <cascader-panel
      v-if="childMenu && childMenu.length"
      :data="childMenu"
      :width="width"
      :height="height"
      @getAcived="getAcived"
    ></cascader-panel>
  </div>
</template>

<script>
import CascaderItem from "./CascaderItem";

export default {
  name: "CascaderPanel",
  components: {
    CascaderItem
  },
  props: {
    data: Array,
    width: {
      type: [Number, String],
      default: 0
    },
    height: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      childMenu: [],
      currentIndex: -1
    };
  },
  watch: {
    data() {
      this.childMenu = [];
      this.currentIndex = -1;
    }
  },
  methods: {
    showChild(item, index) {
      this.currentIndex = index;
      this.childMenu = item.children;
    },
    // enterul(){
    //   this.currentIndex = -1;
    //   this.childMenu = [];
    // },
    handlemouseover(e) {
      // console.log("this is over", e);
      if (e.srcElement.nodeName == "LI") {
        return;
      } else {
        this.currentIndex = -1;
        this.childMenu = [];
      }
    },
    // 获取当前激活的选项
    getAcived(dat) {
      // console.log('获取当前激活的选项 panel ::',dat);
      this.$emit('getAcived', dat);
    },
  }
};
</script>

<style scoped lang="less">
.cascader-panel {
  box-sizing: border-box;
  display: flex;
  min-height: 300px;
  // background-color: green;
  // border: 1px solid #f0f0f0;
  .cascader-panel-ul {
    box-sizing: border-box;
    padding: 1rem 0;
    margin: 0;
    list-style: none;
    border-right: 1px solid #22446e;
  }
}
.isactive {
  color: #fff;
  background-color: #22446e;
}
</style>
